<!-- note that css is not being picked up by css file, hard coded in line styles -->
<div class="container">
        <div class="text-center main-text" style="font-size: 90px; font-weight: bold; color: red;">Logged Out</div>
        <div class="text-center logout-text" style="font-size: 30px;"><div>You have successfully logged out.</div></div>
</div>
